"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteAttribute = exports.updateAttribute = exports.loadAttributes = exports.loadSettingsAttributes = exports.DeleteAttribute = exports.UpdateAttribute = exports.FetchSettingsAttributes = exports.FetchAttributes = exports.DeleteAttributeActionTypes = exports.UpdateAttributeActionTypes = exports.FetchSettingsAttributesActionTypes = exports.FetchAttributesActionTypes = exports.UserAppAttributeActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var UserAppAttributeActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_ATTRIBUTES: null,
  LOAD_SETTINGS_ATTRIBUTES: null,
  FETCH_ATTRIBUTES: null,
  FETCH_SETTINGS_ATTRIBUTES: null,
  UPDATE_ATTRIBUTE: null,
  DELETE_ATTRIBUTE: null
}, _constants.USER_APP_ATTRIBUTE);
exports.UserAppAttributeActionTypes = UserAppAttributeActionTypes;
var FetchAttributesActionTypes = (0, _actions.createRequestTypes)(UserAppAttributeActionTypes.FETCH_ATTRIBUTES);
exports.FetchAttributesActionTypes = FetchAttributesActionTypes;
var FetchSettingsAttributesActionTypes = (0, _actions.createRequestTypes)(UserAppAttributeActionTypes.FETCH_SETTINGS_ATTRIBUTES);
exports.FetchSettingsAttributesActionTypes = FetchSettingsAttributesActionTypes;
var UpdateAttributeActionTypes = (0, _actions.createRequestTypes)(UserAppAttributeActionTypes.UPDATE_ATTRIBUTE);
exports.UpdateAttributeActionTypes = UpdateAttributeActionTypes;
var DeleteAttributeActionTypes = (0, _actions.createRequestTypes)(UserAppAttributeActionTypes.DELETE_ATTRIBUTE);
exports.DeleteAttributeActionTypes = DeleteAttributeActionTypes;
var FetchAttributes = (0, _actions.createRequestActions)(FetchAttributesActionTypes);
exports.FetchAttributes = FetchAttributes;
var FetchSettingsAttributes = (0, _actions.createRequestActions)(FetchSettingsAttributesActionTypes);
exports.FetchSettingsAttributes = FetchSettingsAttributes;
var UpdateAttribute = (0, _actions.createRequestActions)(UpdateAttributeActionTypes);
exports.UpdateAttribute = UpdateAttribute;
var DeleteAttribute = (0, _actions.createRequestActions)(DeleteAttributeActionTypes);
exports.DeleteAttribute = DeleteAttribute;
var loadSettingsAttributes = (0, _fluxActions.createAction)(UserAppAttributeActionTypes.LOAD_SETTINGS_ATTRIBUTES, function () {
  return {
    keys: [_constants.SETTINGS_UI_ACCOUNT_NAME_POPOVER_SEEN, _constants.USERS_AND_TEAMS_ONBOARDING]
  };
});
exports.loadSettingsAttributes = loadSettingsAttributes;
var loadAttributes = (0, _fluxActions.createAction)(UserAppAttributeActionTypes.LOAD_ATTRIBUTES);
exports.loadAttributes = loadAttributes;
var updateAttribute = (0, _fluxActions.createAction)(UserAppAttributeActionTypes.UPDATE_ATTRIBUTE, (0, _actions.mapPayloadTo)('data'));
exports.updateAttribute = updateAttribute;
var deleteAttribute = (0, _fluxActions.createAction)(UserAppAttributeActionTypes.DELETE_ATTRIBUTE, (0, _actions.mapPayloadTo)('userId', 'key'));
exports.deleteAttribute = deleteAttribute;